module.exports = __webpack_public_path__ + "img/bvb-borussia-dortmund.786bc398.png";